module.exports = __webpack_public_path__ + "static/media/CLI Team Profile Generator.7cfc12b2.jpg";